import { useState } from "react";
import {gsap} from 'gsap';

import "./Header.scss";

const Header = () => {

  const d = new Date();
let year = d.getFullYear();

  const [hamburgerActive, setHamburgerActive] = useState(false);
  const [navLinks, setNavLinks] = useState(false);

  const delayCloseNav = () => {
    if (hamburgerActive) {
      setNavLinks(false);
      setTimeout(() => {
        setHamburgerActive(false);
      }, 1000);
    } else {
      setHamburgerActive(true);
      setNavLinks(true);
    }
  };

  const applySVGFilter = () => {
    gsap.to(document.querySelectorAll(`#filter-1 > feTurbulence`), 2, {
      startAt: {turbulence: 0.09},
      turbulence: 0,
      repeat: -1,
      yoyo: true
    });

    
  }

  return (
    <>
      <svg className="hidden">
        <defs>
          <filter id="filter-1">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0"
              numOctaves="1"
              result="warp"
            ></feTurbulence>
            <feOffset dx="-90" result="warpOffset"></feOffset>
            <feDisplacementMap
              xChannelSelector="R"
              yChannelSelector="G"
              scale="30"
              in="SourceGraphic"
              in2="warpOffset"
            ></feDisplacementMap>
          </filter>
          <filter id="filter-2">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0"
              numOctaves="20"
              result="warp"
            ></feTurbulence>
            <feOffset dx="-90" result="warpOffset"></feOffset>
            <feDisplacementMap
              xChannelSelector="R"
              yChannelSelector="G"
              scale="40"
              in="SourceGraphic"
              in2="warpOffset"
            ></feDisplacementMap>
          </filter>
          <filter id="filter-3">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.15 0.02"
              numOctaves="3"
              result="warp"
            ></feTurbulence>
            <feDisplacementMap
              xChannelSelector="R"
              yChannelSelector="G"
              scale="0"
              in="SourceGraphic"
              in2="warp"
            ></feDisplacementMap>
          </filter>
          <filter id="filter-4">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0"
              numOctaves="5"
              result="warp"
            ></feTurbulence>
            <feOffset dx="-90" result="warpOffset"></feOffset>
            <feDisplacementMap
              xChannelSelector="R"
              yChannelSelector="G"
              scale="35"
              in="SourceGraphic"
              in2="warpOffset"
            ></feDisplacementMap>
          </filter>
          <filter id="filter-5">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.01 0.7"
              numOctaves="5"
              result="warp"
            ></feTurbulence>
            <feDisplacementMap
              xChannelSelector="R"
              yChannelSelector="G"
              scale="0"
              in="SourceGraphic"
              in2="warp"
            ></feDisplacementMap>
          </filter>
          <filter id="filter-6">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.01 0.07"
              numOctaves="5"
              seed="2"
              result="noise"
            ></feTurbulence>
            <feDisplacementMap
              in="SourceGraphic"
              in2="warp"
              scale="0"
              xChannelSelector="R"
              yChannelSelector="B"
            ></feDisplacementMap>
          </filter>
          <filter id="filter-7">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0"
              numOctaves="5"
              result="warp"
            ></feTurbulence>
            <feDisplacementMap
              xChannelSelector="R"
              yChannelSelector="G"
              scale="90"
              in="SourceGraphic"
              in2="warp"
            ></feDisplacementMap>
          </filter>
        </defs>
      </svg>
      <div
        className={`nav-overlay ${hamburgerActive ? "is-active" : ""}`}
      ></div>
      <nav className={`navigation ${navLinks ? "is-active" : ""}`}>
        <ul>
          <li>
            <span onClick={() => delayCloseNav()} onMouseEnter={() => applySVGFilter()}>About</span>
          </li>
          <li>
            <span onClick={() => delayCloseNav()}>Projects</span>
          </li>
          <li>
            <span onClick={() => delayCloseNav()}>Contact</span>
          </li>
        </ul>
      </nav>
      <div className="header">
        <div className={`logo ${hamburgerActive ? "dark-logo" : ""}`}>
          ALBAN ― B.
        </div>
        {/* <div
          className={`hamburger-icon ${navLinks ? "is-active" : ""}`}
          onClick={() => delayCloseNav()}
        >
          <span />
          <span />
        </div> */}

        <div className="right">
           Portfolio {year}
        </div>
      </div>
    </>
  );
};

export default Header;
